import React from 'react';
import { Row, Col } from 'antd';

import Input from 'components/formik/Input';
import FormItem from 'components/formik/FormItem';

type Props = {
  formNamePrefix?: string;
  isRequired?: boolean;
  disabled?: boolean;
};

const getCorrectFieldName = (name: string, prefix: string = '') => {
  if (prefix) return `${prefix}.${name}`;

  return name;
};

const getLabel = (label: string, isRequired: boolean) =>
  isRequired ? `${label} *` : label;

export default React.memo((props: Props) => {
  const { formNamePrefix, isRequired = true, disabled = false } = props;

  return (
    <>
      <Col xs={24} md={12}>
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <FormItem
              label={getLabel('First name', isRequired)}
              name={getCorrectFieldName('firstName', formNamePrefix)}
            >
              <Input
                placeholder="Enter first name"
                name={getCorrectFieldName('firstName', formNamePrefix)}
                disabled={disabled}
              />
            </FormItem>
          </Col>

          <Col xs={24} md={12}>
            <FormItem
              label={getLabel('Last name', isRequired)}
              name={getCorrectFieldName('lastName', formNamePrefix)}
            >
              <Input
                placeholder="Enter last name"
                name={getCorrectFieldName('lastName', formNamePrefix)}
                disabled={disabled}
              />
            </FormItem>
          </Col>
        </Row>
      </Col>

      <Col xs={24} md={12}>
        <Row gutter={20}>
          <Col xs={24} md={12}>
            <FormItem
              label={getLabel('Email', isRequired)}
              name={getCorrectFieldName('email', formNamePrefix)}
            >
              <Input
                placeholder="Enter email"
                name={getCorrectFieldName('email', formNamePrefix)}
                disabled={disabled}
              />
            </FormItem>
          </Col>

          <Col xs={24} md={12}>
            <FormItem
              label={getLabel('Phone number', isRequired)}
              name={getCorrectFieldName('phone', formNamePrefix)}
            >
              <Input
                placeholder="Enter phone number"
                name={getCorrectFieldName('phone', formNamePrefix)}
                disabled={disabled}
              />
            </FormItem>
          </Col>
        </Row>
      </Col>
    </>
  );
});
